import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';

var SelectAddress = function (_super) {
  __extends(SelectAddress, _super);

  function SelectAddress() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  SelectAddress.prototype.handleChoose = function (type) {
    this.$emit('submit', {
      selected_region: type,
      status: this.$enum.mine.CustomerStartupStatusEnum.FILL_SIGN_BODY_FORM
    });
  };

  SelectAddress = __decorate([Component], SelectAddress);
  return SelectAddress;
}(Vue);

export default SelectAddress;